export default "__VITE_ASSET__BOjoSuq4__"